// @ts-nocheck

import React from "react";
import { useFormik } from "formik";
import { Image } from "primereact/image";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useSettingsStore } from "../../zustand/useSettings.js";

// logo
import logo from "../../assets/logo.svg";
import eca from "../../assets/eca.png";
import unu from "../../assets/unu.png";

import { isFormFieldValid, getFormErrorMessage } from "../../util/formikUtils";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
  loginSuccess,
  loginError,
  resetActionType,
} from "../../redux/slices/AuthenticateSlice";
import { loginMiddleware } from "../../redux/middlewares/AuthenticateMiddleware";
import { goToAppPage } from "../../redux/slices/NavigationSlice";
import LanguageSelect from "../../components/customs/LanguageSelect";
import { Translate } from "react-auto-translate";

export default function LoginPage(props) {
  const dispatch = useDispatch();
  const authenticateState = useSelector((state) => state.authenticate);
  const lang = useSettingsStore((store) => store.lang);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validate: (values) => {
      const errors = {};
      if (!values.email) {
        errors.email = "Email is required.";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address. E.g. example@email.com";
      }

      if (!values.password) {
        errors.password = "Password is required";
      }
      return errors;
    },

    onSubmit: (values) => {
      dispatch(loginMiddleware(values.email, values.password));
    },
  });

  React.useEffect(() => {
    if (authenticateState.ACTION_TYPE === loginSuccess.toString()) {
      dispatch(goToAppPage());
      dispatch(resetActionType());
    } else if (authenticateState.ACTION_TYPE === loginError.toString()) {
      toast.error(authenticateState.loginMessage);
      dispatch(resetActionType());
    }
  }, [authenticateState.ACTION_TYPE]);

  return (
    <main className="h-screen relative overflow-y-scroll">
      <div className="h-full relative flex flex-column lg:flex-row">
        <div className="lg:h-full col-12 lg:col-6 p-3 md:p-5 lg:py-8 flex flex-column">
          <div className="w-12 md:w-10 lg:w-9 align-self-center">
            <div className="mt-3 flex gap-3">
              <Image src={logo} imageClassName="h-2rem md:h-3rem" />
              <LanguageSelect />
            </div>

            <div className="flex flex-column mt-8 text-3xl md:text-5xl">
              <strong>
                <Translate> Log in to the JUSTIS</Translate>
              </strong>
              <strong>
                <Translate> Social Portal</Translate>
              </strong>
            </div>

            <form
              onSubmit={formik.handleSubmit}
              className="w-full flex flex-column mt-5"
            >
              <div className="p-fluid mb-3 mt-4">
                <div className="mb-3">
                  <label
                    htmlFor="email"
                    className={classNames({
                      "p-error": isFormFieldValid(formik, "email"),
                      "font-medium": true,
                    })}
                  >
                    <Translate>Email*</Translate>
                  </label>
                </div>
                <span className="p-input-icon-left">
                  <i className="pi pi-envelope font-bold text-color" />

                  <InputText
                    id="email"
                    name="email"
                    placeholder= {lang === 'fr' ? "nom@domaine.com": "name@domain.com"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    className={classNames({
                      "p-invalid": isFormFieldValid(formik, "email"),
                      "p-inputtext-lg": true,
                    })}
                  />
                </span>
                <div className="mt-2">
                  {getFormErrorMessage(formik, "email")}
                </div>
              </div>

              <div className="my-3 flex justify-content-end"></div>

              <div className="p-fluid mb-6">
                <div className="mb-3 flex justify-content-between">
                  <label
                    htmlFor="password"
                    className={classNames({
                      "p-error": isFormFieldValid(formik, "password"),
                      "font-medium": true,
                    })}
                  >
                    <Translate>Password*</Translate>
                  </label>

                  <Link
                    to="/forgot-password"
                    className="no-underline text-primary-800  hover:text-primary-600"
                  >
                    <Translate>Forgot Password</Translate>
                  </Link>
                </div>
                <span className="p-input-icon-left">
                  <i className="pi pi-lock font-bold text-color z-5" />

                  <Password
                    id="password"
                    name="password"
                    feedback={false}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    inputStyle={{ paddingLeft: 40 }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        formik.handleSubmit();
                      }
                    }}
                    toggleMask
                    className={classNames({
                      "p-invalid": isFormFieldValid(formik, "password"),
                      "p-inputtext-lg": true,
                    })}
                  />
                </span>

                <div className="mt-2">
                  {getFormErrorMessage(formik, "password")}
                </div>
              </div>

              <div className="p-fluid mb-6">
                <Button
                  type="submit"
                  label={<Translate>Login</Translate>}
                  loading={authenticateState.isLoginLoading}
                  className="p-button-raised p-button-lg"
                />
              </div>
            </form>

            <div className="mb-3 text-center">
              <Link
                to="/register"
                className="no-underline text-md md:text-lg text-primary-800  hover:text-primary-600"
              >
                <p className="text-md m-0 ">
                  <Translate>Need an account? Sign up here</Translate>
                </p>
              </Link>
            </div>
          </div>
        </div>
        <div className="h-full flex-auto flex  flex-column login-image lg:justify-content-end">
          {/* <div className="p-7 login w-10 align-self-center my-5">
            <div>
              <strong className="text-white text-4xl">
                <Translate>INFORMATION SESSION</Translate>
              </strong>
            </div>

            <div>
              <p className="text-lg text-white font-medium">
                <Translate>
                  An INFoCAT Innovation Call Information session will be held
                  focusing on Project details, Call application guidance,
                  UNU-INRA rules/selection criteria, filling online form, and
                  the evaluation process. Q& A session will provide opportunity
                  to ask the UNU team all questions pertaining to the Innovation
                  Call.
                </Translate>
              </p>

              <p className="text-lg text-white font-medium">
                <Translate>DATE: May 24, 2024</Translate> <br />
                <Translate>TIME: 10.00am – 12.00pm</Translate> <br />
                <Translate>Venue: Virtual (Online)</Translate>
              </p>

              <p className="text-lg text-white font-medium">
                <Translate>Meeting details</Translate>
                <br />
                <a
                  className="text-primary"
                  href="https://unu-edu.zoom.us/meeting/register/tJ0kf-qhrzkiHtS4pMj3xL5pdL1N3ZWIK6g1 "
                >
                  <Translate>Register by clicking here</Translate>
                </a>
                <br /> <br />
                <Translate>
                  After registering, you will receive a confirmation email
                  containing information about joining the meeting.
                </Translate>
              </p>
            </div>
          </div> */}

          <div className="p-7 login w-10 align-self-center mb-5">
            <div>
              <strong className="text-white text-4xl">
                <Translate>
                  Connect, engage and unlock potential investments
                </Translate>
              </strong>
            </div>

            <div>
              <p className="text-lg text-white font-medium">
                <Translate>
                  The JUSTIS digital portal seeks to bridge the gap between
                  green entrepreneurs, policymakers, and investors to accelerate
                  green growth and green transitions.
                </Translate>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
